import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const isAuthenticated = !!localStorage.getItem('accessToken'); // Check for token. uncoment after developement

    // If not authenticated, redirect to login page
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
